import Vue from 'vue'
import App from './App'

// import global_ from './global/global'//引用文件

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/fontIcon/iconfont.css'
import 'babel-polyfill';
require('es6-promise').polyfill();
import 'fetch-detector';
import 'fetch-ie8';
import i18n from './i18n/i18n';
import messages from './i18n/langs/index'

import router from './router'
import store from './store/'
import Tools from './global/util';
import './config/dialog'

import {
  getJsonResource,
} from "@/api/getData";
import {
  getLocal,
  getStore
} from '@/config/mUtils';
//加密解密
import JSEncrypt from "jsencrypt/bin/jsencrypt"

// import axios from './config/axios'

let Base64 = require('js-base64').Base64;
Vue.config.productionTip = false;

Vue.prototype.$jsEncrypt = JSEncrypt

import VueMatomo from 'vue-matomo'
Vue.use(VueMatomo, {
  host: 'https://matomo.fresenius-kabi.com.cn/', // 你自己的matomo地址
  siteId: 1,//siteId值，这个值页需要去matomo上去申请
  // 根据router自动注册，需要注意的是如果有路由传值值太长的话matomo会监听不到并报414，就不能使用此方法了。解决：app.vue监听路由
  router: router,
  // 是否需要在发送追踪信息之前请求许可，默认false
  requireConsent: false,
  enableLinkTracking: true,
  // 是否追踪初始页面，默认true
  trackInitialView: false,
  // 最终的追踪js文件名，matomo版本比较老，使用的是piwik，现在新版本的话此值为matomo
  trackerFileName: 'matomo',
  debug: false
});


//获取语言资源包
// Vue.prototype.getLanguageResource = async function (){
//     const crs = await getJsonResource();
//     if(crs.Flag){
//         cn.message = Object.assign({},cn.message, crs.Result.zh_CN);
//         en.message = Object.assign({},en.message, crs.Result.en_US);

//         if (getLocal('language') == 'zh_CN') {
//             this.$i18n.locale = "cn";
//         }
//         if (getLocal('language') == 'en_US') {
//             this.$i18n.locale = "en";

//         } else {
//             this.$i18n.locale = "cn";
//         }
//     }
// }

// 自定义共同方法(this，MessgeName,type类型)
Vue.prototype.PublicMsg = function (that,msg,msgType){
  if(msg!=undefined){
    if(that.$t('message.'+msg).indexOf("message.") != -1){
      that.$message({
        message: msg,
        type: msgType
      });
    }else{
      that.$message({
        message: that.$t('message.'+msg),
        type: msgType
      });
    }
  }
}

if (language != undefined) {
  messages.enUS.message = language.en;
  messages.zhCN.message = language.zhCN;
}
Vue.use(ElementUI).use(Tools);
// axios.install(Vue);
//注释
// Tools.dispatchEventStroage();
// axios.install(Vue);

let vue = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: {
    App
  }
})
export default vue




// WEBPACK FOOTER //
// ./src/main.js